module.exports = __webpack_public_path__ + "static/media/blueberry-flavour.a0d37d65.png";